import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { RouteNavigation } from "../../../Routes";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosClose } from "react-icons/io";
import { NavLink } from "react-router-dom";

function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const [scroll, setScroll] = useState(false);
  const location = useLocation();
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 100);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        setScroll(window.scrollY > 100);
      });
    };
  }, [scroll]);

  let stickyHeader;
  if (location.pathname === "/" && scroll === false) {
    stickyHeader = "relative";
  } else {
    stickyHeader = "sticky top-0 z-50 animate-page-header";
  }
  const HeaderStyling =
    location.pathname === "/" && !scroll
      ? "bg-white top-0 text-black z-50"
      : "bg-white text-black";

  return (
    <header className={`${HeaderStyling} ${stickyHeader} w-full`}>
      <div className="flex flex-wrap px-1 sm:px-10 py-5 flex-row items-center ">
        <a href="/" className="flex title-font font-medium items-center sm:m-0">
          <img
            className="w-28 min-[400px]:w-32"
            src="/images/mobi_pos_logo.svg"
            alt="logo"
          />
        </a>
        <nav className="hidden lg:flex poppins_light flex-wrap items-center text-base justify-center space-x-14 ml-10">
          <NavLink
            to={RouteNavigation.home}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Home
          </NavLink>
          <NavLink
            to={RouteNavigation.about}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            About Us
          </NavLink>
          <NavLink
            to={RouteNavigation.products}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Product
          </NavLink>
          <NavLink
            to={RouteNavigation.solution}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Solutions
          </NavLink>
          <NavLink
            to={RouteNavigation.partnerhip}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Partnership
          </NavLink>
          <NavLink
            to={RouteNavigation.blog}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Blog
          </NavLink>
          <NavLink
            to={RouteNavigation.contact}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                  ? "poppins_semibold border-b-2 inset-2 border-[#f6892f]"
                  : ""
            }
          >
            Contact Us
          </NavLink>
        </nav>

        <Link
          to={RouteNavigation.ScheduleDemo}
          className={`inline-flex ml-auto poppins_light items-center border border-black bg-white text-black py-1 px-3 rounded text-sm min-[400px]:text-base`}
        >
          Get Free Demo
        </Link>
        <div className="block lg:hidden ml-3">
          <RxHamburgerMenu
            className="w-[30px]"
            onClick={() => setShowMenu(!showMenu)}
          />
        </div>
      </div>
      <div
        className={`fixed top-0 bottom-0 w-[75%] h-screen bg-white transition-transform duration-300 ease-linear lg:translate-x-[100%] lg:-right-[160px] ${
          showMenu
            ? "translate-x-0 right-0"
            : "translate-x-[100%] -right-[160px]"
        }`}
      >
        <button onClick={() => setShowMenu(!showMenu)} className="p-0 ">
          <IoIosClose size="30px" />
        </button>
        <ul className="px-10 py-5 text-center space-y-5 text-black poppins_light">
          <li className="hover:bg-[#f8e0cb] w-full">
            <Link to={RouteNavigation.home} onClick={() => setShowMenu(false)}>
              Home
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full">
            <Link to={RouteNavigation.about} onClick={() => setShowMenu(false)}>
              About Us
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full">
            <Link
              to={RouteNavigation.products}
              onClick={() => setShowMenu(false)}
            >
              Product
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full cursor-pointer">
            <Link
              to={RouteNavigation.solution}
              onClick={() => setShowMenu(false)}
            >
              Solutions
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full cursor-pointer">
            <Link
              to={RouteNavigation.partnerhip}
              onClick={() => setShowMenu(false)}
            >
              Partnership
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full">
            <Link to={RouteNavigation.blog} onClick={() => setShowMenu(false)}>
              Blog
            </Link>
          </li>
          <li className="hover:bg-[#f8e0cb] w-full">
            <Link
              to={RouteNavigation.contact}
              onClick={() => setShowMenu(false)}
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
